<template>
<v-card>
  <v-card-text>
    <v-textarea
      :loading="loading"
      :disabled="loading"
      name="input-7-1"
      :label="labelText"
      rows="1"
      auto-grow
      v-model="inputData"
      v-on:input="validate"
      required
    />
    <v-alert v-if="error" text dense type="error">
      {{ error }}
    </v-alert>
  </v-card-text>
  <v-card-actions>
    <v-spacer/>
    <v-btn :disabled="loading" class="secondary" @click="close">Cancel</v-btn>
    <v-btn :loading="loading" :disabled="!valid"  @click="submitForm(inputData)" class="primary">Save</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
export default {
  name: 'UnitAliasForm',
  props: {
    labelText: {
      type: String,
      default: 'Button Text'
    },
    error: {
      type: String,
      default: ''
    },
    initialInputValue: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      inputData: '',
      loading: false,
      valid: false
    }
  },
  created () {
    this.inputData = this.initialInputValue
  },
  methods: {
    submitForm: function (inputValue) {
      this.loading = true
      this.$emit('submit-form', inputValue)
    },
    resetData: function () {
      this.inputData = this.initialInputValue
      this.loading = false
      this.valid = false
    },

    close: function () {
      this.resetData()
      this.$emit('close')
    },

    validate: function () {
      this.valid = this.inputData !== this.initialInputValue
    }
  }
}
</script>

<style scoped>

</style>
